import { useCallback, useEffect, useRef } from 'react'

type UseDropdownPositionProps = {
  active: boolean
}

export const useDropdownPosition = ({
  active,
}: UseDropdownPositionProps): React.RefObject<HTMLDivElement> => {
  const menuItemRef = useRef<HTMLDivElement | null>(null)

  const calculateDropdownPosition = useCallback((): void => {
    const menuItem: HTMLDivElement | null = menuItemRef.current
    if (!menuItem) return

    const dropdown: HTMLElement | null = menuItem.querySelector('.dropdown')
    if (!dropdown) return

    const windowWidth: number = window.innerWidth
    const menuItemBounds: DOMRect = menuItem.getBoundingClientRect()
    const menuItemCenter: number = menuItemBounds.left + menuItem.offsetWidth / 2
    const dropdownWidth: number = dropdown.offsetWidth

    const dropdownLeft: number = menuItemCenter - dropdownWidth / 2
    const dropdownRight: number = menuItemCenter + dropdownWidth / 2

    let offset: string = '0px'
    if (dropdownLeft < 0) {
      offset = `${dropdownLeft * -1}px`
    } else if (dropdownRight > windowWidth) {
      offset = `${windowWidth - dropdownRight}px`
    }

    menuItem.style.setProperty('--mega-menu-offset', offset)
  }, [])

  // Calculate starting positions on mount
  useEffect((): void => {
    calculateDropdownPosition()
  }, [calculateDropdownPosition])

  // Recalculate positions on resize
  useEffect((): (() => void) => {
    if (active) {
      calculateDropdownPosition()
      window.addEventListener('resize', calculateDropdownPosition)
    }

    return (): void => {
      window.removeEventListener('resize', calculateDropdownPosition)
    }
  }, [active, calculateDropdownPosition])

  return menuItemRef
}
